import cx from 'classnames';
import React from 'react';

import Styles from './styles.module.scss';

type ButtonProps = React.ComponentProps<'button'> & {
    fullWidth?: boolean; // have the button expand to the size of the container
    showButtonWires?: boolean; // this is the background image
}

export function BankxButton(props: React.PropsWithChildren<ButtonProps>): React.ReactElement {
    const {
        children,
        showButtonWires = false,
        fullWidth = false,
        ...buttonProps
    } = props;

    return (
        <button {...buttonProps} className={cx(Styles.button, {
            [Styles.buttonFull]: fullWidth,
            [Styles.buttonGlow]: showButtonWires,
            [Styles.buttonWires]: showButtonWires,
        })}>
            <div className={Styles.buttonOuter}>
                <div className={Styles.buttonInner}>
                    {children}
                </div>
            </div>
        </button>
    );
}
